
class IntegratorConfigKeyValueCell extends UITableViewCell
{
    private keyTextField: MUITextField = null;
    private valueTextField: MUITextField = null;

    awakeFromHTML() {
        this.keyTextField = MUIOutlet(this, "key-tf", "MUITextField");
        this.keyTextField.setOnChangeText(this, function(tf: MUITextField, value: string) {
            if (this._key != null && this._configValues != null) {
                let oldValue = this._configValues[this._key];
                delete this._configValues[this._key];
                this._key = value;
                this._configValues[this._key] = oldValue;
                if (this._config != null) this._config.configValues = this._configValues;
            }
        });

        this.valueTextField = MUIOutlet(this, "value-tf", "MUITextField");
        this.valueTextField.setOnChangeText(this, function(tf: MUITextField, value: string) {
            if (this._key != null && this._configValues != null) {
                // JSON values (arrays/objects) round-trip as JSON — everything else
                // stays a plain string.
                let v: any = value;
                let t = value.trim();
                if (t.length > 0 && (t.charAt(0) == "[" || t.charAt(0) == "{")) {
                    try { v = JSON.parse(t); } catch (e) { /* keep the raw text while typing */ }
                }
                this._configValues[this._key] = v;
                if (this._config != null) this._config.configValues = this._configValues;
            }
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private _key: string = null;
    private _configValues: any = null;
    private _config: IntegratorConfig = null;

    setKeyValue(key: string, value: any, configValues: any, config: IntegratorConfig) {
        this._key = key;
        this._configValues = configValues;
        this._config = config;

        this.keyTextField.text = key;
        this.valueTextField.text = value == null ? ""
                                 : typeof value == "string" ? value
                                 : JSON.stringify(value);
    }
}
